<template>
	<div id="app">
		<v-app dark>
			<v-app-bar app color="primary" dark>
				<div class="d-flex align-center">
					<router-link to="/">
						<v-img
							alt="Vuetify Logo"
							class="shrink mr-2"
							contain
							:src="require('./assets/UA_Logo_WHT_RGB.png')"
							transition="scale-transition"
							width="140"
						/>
					</router-link>

					<!-- <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
          />-->
				</div>

				<v-spacer></v-spacer>

				<v-btn v-if="auth.loggedIn" v-on:click="logout" text>
					<span class="mr-2">Logout</span>
					<v-icon>mdi-open-in-new</v-icon>
				</v-btn>
				<v-btn v-else v-on:click="login" text>
					<span class="mr-2">Login</span>
					<v-icon>mdi-open-in-new</v-icon>
				</v-btn>
			</v-app-bar>

			<v-main>
				<router-view></router-view>
			</v-main>
		</v-app>
	</div>
</template>

<script>
// import MainContent from './views/Home';
import { mapGetters, mapActions } from "vuex";

export default {
	name: "App",

	// components: {
	//   MainContent,
	// },

	data: () => ({
		//
	}),
	computed: {
		...mapGetters(["auth"]),
	},
	methods: {
		...mapActions({
			login: "login",
			logout: "logout",
		}),
	},
};
</script>

<style scoped>
.mdi-open-in-new::before {
	font-size: 20px;
}
</style>
